import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_VN_UQ || "uq.vn.new-styling-book",
  ugcClientId: process.env.REACT_APP_UGC_CLIENT_ID_VN_UQ || "uqvn-sth-sb-proxy",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_VN_UQ || 27539,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_VN_UQ || 27540,
  firebaseApiKey: process.env.REACT_APP_FIREBASE_API_KEY_VN_UQ || "",
  firebaseProjectId: process.env.REACT_APP_FIREBASE_PROJECT_ID_VN_UQ || "",
  firebaseAppId: process.env.REACT_APP_FIREBASE_APP_ID_VN_UQ || "",
  firebaseMeasurementId:
    process.env.REACT_APP_FIREBASE_MEASUREMENT_ID_VN_UQ || "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: true,
  languages: [LANGUAGE.EN, LANGUAGE.VI],
  countryRegion: "Asia/Ho_Chi_Minh",
  timeZone: {
    [LANGUAGE.EN]: {
      defaultTimezone: "ICT",
      offset: {
        ICT: +7,
        "GMT+7": +7,
        "GMT+8": +7
      }
    },
    [LANGUAGE.VI]: {
      defaultTimezone: "ICT",
      offset: {
        ICT: +7,
        "GMT+7": +7,
        "GMT+8": +7
      }
    }
  },
  timeZoneParentCategory: {
    "GMT+8": "ICT",
    "GMT+7": "ICT"
  },
  dateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>/<yyyy>",
    [LANGUAGE.VI]: "<dd>/<mm>/<yyyy>"
  },
  shortDateFormat: {
    [LANGUAGE.EN]: "<dd>/<mm>",
    [LANGUAGE.VI]: "<dd>/<mm>"
  },
  requireDecimal: false,
  memberPricingEnabled: true
};

export default _countryEnv;
